export default function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isRegExp.js
// module id = 1118
// module chunks = 0